import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getWebAppsPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/vyvoj/webove-aplikace",
		[Locale.en]: "/development/web-apps",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
